/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M7 7.99976L7 15.9998M12 10.9998V15.9998M17 8.99976L17 15.9998"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M7 8L7 16M12 11V16M17 9V16M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25L14.75 1.25C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27434 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25L22.75 14.75L22.75 14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75L9.25 22.75C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75L1.25 9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27434 3.98005 1.79497ZM7.74991 8.00024C7.74991 7.58603 7.41412 7.25024 6.99991 7.25024C6.5857 7.25024 6.24991 7.58603 6.24991 8.00024L6.24991 16.0002C6.24991 16.4145 6.5857 16.7502 6.99991 16.7502C7.41412 16.7502 7.74991 16.4145 7.74991 16.0002L7.74991 8.00024ZM17.7499 9.00024C17.7499 8.58603 17.4141 8.25024 16.9999 8.25024C16.5857 8.25024 16.2499 8.58603 16.2499 9.00024L16.2499 16.0002C16.2499 16.4145 16.5857 16.7502 16.9999 16.7502C17.4141 16.7502 17.7499 16.4145 17.7499 16.0002L17.7499 9.00024ZM12.7499 11.0002C12.7499 10.586 12.4141 10.2502 11.9999 10.2502C11.5857 10.2502 11.2499 10.586 11.2499 11.0002L11.2499 16.0002C11.2499 16.4145 11.5857 16.7502 11.9999 16.7502C12.4141 16.7502 12.7499 16.4145 12.7499 16.0002L12.7499 11.0002Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M14.5 2H15V2C16.8613 2 17.7919 2 18.5451 2.24472C20.0673 2.73931 21.2607 3.93273 21.7553 5.45492C22 6.20808 22 7.13872 22 9V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V9C2 7.13872 2 6.20808 2.24472 5.45492C2.73931 3.93273 3.93273 2.73931 5.45492 2.24472C6.20808 2 7.13872 2 9 2V2H9.5M7 8L7 16M12 11V16M17 9V16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M7 8L7 16M12 11V16M17 9V16M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7 7.25024C7.41421 7.25024 7.75 7.58603 7.75 8.00024L7.75 16.0002C7.75 16.4145 7.41421 16.7502 7 16.7502C6.58579 16.7502 6.25 16.4145 6.25 16.0002L6.25 8.00024C6.25 7.58603 6.58579 7.25024 7 7.25024ZM17 8.25024C17.4142 8.25024 17.75 8.58603 17.75 9.00024L17.75 16.0002C17.75 16.4145 17.4142 16.7502 17 16.7502C16.5858 16.7502 16.25 16.4145 16.25 16.0002L16.25 9.00024C16.25 8.58603 16.5858 8.25024 17 8.25024ZM12 10.2502C12.4142 10.2502 12.75 10.586 12.75 11.0002L12.75 16.0002C12.75 16.4145 12.4142 16.7502 12 16.7502C11.5858 16.7502 11.25 16.4145 11.25 16.0002L11.25 11.0002C11.25 10.586 11.5858 10.2502 12 10.2502Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
